// extracted by mini-css-extract-plugin
export default {"heroSubTitle":"heroBlock_heroSubTitle__U03Zv","heroBtn":"heroBlock_heroBtn__sosl1","heroSocbar":"heroBlock_heroSocbar__xj6YX"};